import type { FunctionComponent } from 'react';
import classNames from 'classnames';

import type { Avatars } from '@trello/business-logic/member';
import { MemberAvatarUnconnected } from '@trello/member-avatar';
import type { PIIString } from '@trello/privacy';
import { EMPTY_PII_STRING } from '@trello/privacy';

import styles from './MemberHomeHeader.less';

interface MemberHomeHeaderProps {
  id: string;
  initials: PIIString;
  username: PIIString;
  name?: PIIString;
  avatars?: Avatars;
}

export const MemberHomeHeader: FunctionComponent<MemberHomeHeaderProps> = ({
  id,
  name = EMPTY_PII_STRING,
  username = EMPTY_PII_STRING,
  avatars,
  initials,
}) => {
  if (!id || !username) return null;

  return (
    <div className={styles.homeHeader}>
      <div className={classNames(styles.avatar)}>
        <MemberAvatarUnconnected
          fullName={name}
          username={username}
          initials={initials}
          avatars={avatars}
          size={48}
        />
      </div>
      <div className={styles.details}>
        {name ? <span className={styles.name}>{name}</span> : null}
        <span className={styles.username}>@{username}</span>
      </div>
    </div>
  );
};
